import { rankings } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-12 md:py-16 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950 mb-2">
            吃瓜热度榜
          </h2>
          <p className="text-sm text-foreground-500">全网黑料视频实时热度排行，看看今天大家都在关注什么</p>
        </div>
        <div className="max-w-[800px] mx-auto">
          {rankings.map((item, i) => (
            <div
              key={i}
              className="flex items-center gap-3 md:gap-4 py-3.5 md:py-4 border-b border-background-200/70 last:border-b-0 group cursor-pointer hover:bg-accent-50/50 px-3 md:px-4 rounded-lg transition-colors"
            >
              <div
                className={`w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-lg font-bold text-sm flex-shrink-0 ${
                  i < 3
                    ? 'bg-accent-500 text-background-50'
                    : 'bg-background-200 text-foreground-500'
                }`}
              >
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className="text-sm md:text-base text-foreground-800 group-hover:text-primary-500 transition-colors line-clamp-1 font-medium">
                    {item.title}
                  </span>
                  {item.hot && (
                    <span className="flex-shrink-0 text-[10px] font-bold px-1.5 py-0.5 rounded bg-accent-100 text-accent-700 whitespace-nowrap">
                      HOT
                    </span>
                  )}
                </div>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0">
                {item.change === 'up' && (
                  <span className="text-xs font-semibold text-accent-600 flex items-center gap-0.5">
                    <i className="ri-arrow-up-line text-xs"></i>
                  </span>
                )}
                {item.change === 'down' && (
                  <span className="text-xs font-semibold text-foreground-400 flex items-center gap-0.5">
                    <i className="ri-arrow-down-line text-xs"></i>
                  </span>
                )}
                {item.change === 'new' && (
                  <span className="text-xs font-semibold text-primary-500 whitespace-nowrap">NEW</span>
                )}
                <span className="text-xs text-foreground-500 whitespace-nowrap">{item.views}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}